import { IBaseAction } from '@models/actions/IBaseAction';
import { DocBaseActionExecutor } from '@organisms/actions/DocBaseActionExecutor';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import { RouteNames } from '@/router/router.types';

export class OpenDocumentExecutor extends DocBaseActionExecutor {
    runInternal = (
        objId: string,
        _parentId: string | undefined,
        action: IBaseAction,
        _rowData?: any,
        completeHandler?: (isSucceed: boolean) => void,
    ) => {
        const serv = new DocumentExecutionService(objId);
        serv.getOpenDocumentModel(action.key).then((res) => {
            if (action.options.openInNewTab) {
                window.open(`.${RouteNames.DOCUMENT.replace(':id', res.data.docId)}`, '_blank');
            } else {
                if (this.navigate) {
                    this.navigate(RouteNames.DOCUMENT.replace(':id', res.data.docId));
                } else {
                    window.location.href = `.${RouteNames.DOCUMENT.replace(':id', res.data.docId)}`;
                }
            }
            completeHandler && completeHandler(false);
        });
    };
}
